(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOWebapi"), require("FEGOVue"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOWebapi", "FEGOVue"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/invite-guide/render"] = factory(require("VueDemi"), require("FEGOWebapi"), require("FEGOVue"));
	else
		root["/fego/component/invite-guide/render"] = factory(root["VueDemi"], root["FEGOWebapi"], root["FEGOVue"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__59906__, __WEBPACK_EXTERNAL_MODULE__55113__, __WEBPACK_EXTERNAL_MODULE__29666__) => {
return 